import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { KanbanBoard, ToastProvider } from '@/components/ui';
import { OperationsProvider } from '../operations/OperationsProvider';
import { useOperations } from '../operations/operationsContext';
import { COLUMNS, SAMPLE_NOW } from '../operations/model';
import { Code } from './Section';

export function BoardPatternTile() {
  return (
    <div
      data-slot="board-pattern-tile"
      className="min-w-0 overflow-hidden rounded-lg border border-line bg-card"
    >
      <header className="flex flex-wrap items-center gap-4 border-b border-line p-5">
        <div className="min-w-0 flex-1">
          <h3 className="type-heading">Доска по статусам</h3>
          <p className="mt-1 text-sm text-fg-muted">
            Число и суммы по валютам. Переноси за ручку мышью или клавиатурой; действие можно отменить.
          </p>
        </div>
        <Link
          to="/design/operations?demo=board"
          className="inline-flex h-9 items-center gap-2 rounded-md border border-line bg-muted px-3 text-xs font-semibold text-fg hover:bg-hover focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
        >
          Открыть образец
          <ArrowRight className="size-4" />
        </Link>
      </header>
      <div className="p-5">
        <ToastProvider>
          <OperationsProvider>
            <TileBoard />
          </OperationsProvider>
        </ToastProvider>
      </div>
      <p className="border-t border-line p-4">
        <Code>KanbanBoard · BoardColumn · BoardItem · Money · Deadline · Toast</Code>
      </p>
    </div>
  );
}
function TileBoard() {
  const { cards, move } = useOperations();
  return (
    <KanbanBoard columns={COLUMNS} items={cards} onMove={move} now={SAMPLE_NOW} label="Доска в галерее" />
  );
}
